import {
    ListItem,
    ListItemAvatar,
    ListItemText,
    Box,
    List,
    Grid,
} from '@mui/material';
import Icon from '@apigrowfinance/pbolt-icon';
import { RiBillLine } from 'react-icons/ri';
import { FormattedMessage } from 'react-intl';

const NoStatements = () => {
    return (
        <Grid
            item
            xs={12}
            sx={{ mt: 3, mb: 3 }}
            data-testid="no-statements-component">
            <Box
                sx={{
                    bgcolor: 'background.paper',
                    width: '100%',
                }}>
                <List>
                    <ListItem
                        data-testid="no-statements-header-component"
                        sx={{ pl: 1 }}>
                        <ListItemAvatar>
                            <Icon data-testid="bill-icon">
                                <RiBillLine />
                            </Icon>
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                <FormattedMessage
                                    id="AccountStatements.noStatementMessage"
                                    defaultMessage="No Statements"
                                />
                            }
                            secondary={
                                <FormattedMessage
                                    id="AccountStatements.noStatementHeader"
                                    defaultMessage="No statements were found for this account"
                                />
                            }
                        />
                    </ListItem>
                </List>
            </Box>
        </Grid>
    );
};

export default NoStatements;
